import { useCallback, useMemo, useSyncExternalStore } from 'react';

export const useMediaQuery = (query: string) => {
  const mediaQueryList = useMemo(() => window.matchMedia(query), [query]);

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      mediaQueryList.addEventListener('change', onStoreChange);

      return () => mediaQueryList.removeEventListener('change', onStoreChange);
    },
    [mediaQueryList],
  );

  return useSyncExternalStore(subscribe, () => mediaQueryList.matches);
};
